import {configureStore} from '@reduxjs/toolkit'
import projectReducer from './project/projectSlice'
import reportReducer from './report/reportReducer'
import interviewReducer from './interview/interviewSlice'
import geofencingReducer from './geofencing/geofencingSlice'
import journeyTimeReducer from './journeyTime/journeyTimeSlice'
import coordinateReducer from './coordinate/coordinateSlice'
import checkListReducer from './checklist/checklistSlice'
import parkingReducer from './parking/parkingSlice'
import dashboardReducer from './dashboard/dashboardSlice'
import countryReducer from './utils/countrySlice'

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    project: projectReducer,
    report: reportReducer,
    interview: interviewReducer,
    geofencing: geofencingReducer,
    journeyTime: journeyTimeReducer,
    coordinate: coordinateReducer,
    checkList: checkListReducer,
    parking: parkingReducer,
    country: countryReducer,
  },
  devTools: process.env.REACT_APP_NODE_ENV !== 'production',
})

export default store
export type RootState = ReturnType<typeof store.getState>
